import {
  descriptionUI,
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SignInAlert from '../../components/FormAlerts/SignInAlert';
import content from '../../locales/en/content.json';

const SCHEMA_ENUM = ['applicant', 'sponsor', 'other'];

const TITLE_TEXT = content['app-status--role-title--new'];
const INPUT_LABEL = content['app-status--role-label'];

const SCHEMA_LABELS = {
  applicant: content['app-status--role-option--new-applicant'],
  sponsor: content['app-status--role-option--new-sponsor'],
  other: content['app-status--role-option--new-other'],
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...descriptionUI(SignInAlert),
    certifierRole: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
      enableAnalytics: true,
    }),
  },
  schema: {
    type: 'object',
    required: ['certifierRole'],
    properties: {
      certifierRole: radioSchema(SCHEMA_ENUM),
    },
  },
};
